/**
 * Set data label size based on chart width.
 *
 * @param context
 * @returns {{weight: string, size: number}}
 */
function responsiveDataLabelSize(context) {
	let minFontSize = 10;
	let maxFontSize = 12;
	let minWidth = 300;
	let maxWidth = 600;

	let width = context.chart.width;
	let size = minFontSize + (maxFontSize - minFontSize) * (width - minWidth) / (maxWidth - minWidth);

	return {
		weight: 'bold',
		size: Math.max(minFontSize, Math.min(size, maxFontSize)),
	}
}

/**
 * Set tick label size based on chart width.
 *
 * @param context
 * @returns {{size: number}}
 */
function responsiveTickLabelSize(context) {
	let minFontSize = 9;
	let maxFontSize = 13;
	let minWidth = 300;
	let maxWidth = 1000;

	let width = context.chart.width;
	let size = minFontSize + (maxFontSize - minFontSize) * (width - minWidth) / (maxWidth - minWidth);

	return {
		size: Math.max(minFontSize, Math.min(size, maxFontSize)),
	}
}

/**
 * Default colors for lines/bars.
 */
const legendColors = {
	gray: 'rgb(172, 200, 207)',
	namer: 'rgb(151,215,0)',
	latam: 'rgb(0,153,168)',
	apac: 'rgb(76,71,196)',
	magenta: 'rgb(255,89,89)',
	emea: 'rgb(0,96,104)'
};

/**
 * Generate color schemes based on region.
 *
 * @param theme
 * @returns {{}}
 */
function chartColors(theme) {
	switch (theme) {
		case 'namer':
			return {
				namer: legendColors.namer,
				gray: legendColors.gray,
			}
		case 'apac':
			return {
				apac: legendColors.apac,
				gray: legendColors.gray,
			}
		case 'emea':
			return {
				emea: legendColors.emea,
				gray: legendColors.gray,
			}

		case 'latam':
			return {
				latam: legendColors.latam,
				gray: legendColors.gray,
			}
		case 'gray':
			return {
				gray: 'rgb(172, 200, 207)',
				light_gray: 'rgb(211, 226, 227)',
			}
		default:
			return legendColors;
	}
}

/**
 * Set label and background colors based on light/dark theme.
 *
 * @param schemeSetting
 * @returns {{}}
 */
function colorScheme(schemeSetting) {
	let colorScheme = {};
	if ('light' === schemeSetting || 'medium-light' === schemeSetting) {
		colorScheme.labels = 'rgb(0, 0, 0)';
		colorScheme.background = 'rgb(255, 255, 255)';
		colorScheme.grid = 'rgb(230, 230, 2305)';
	} else {
		colorScheme.labels = 'rgb(245, 245, 245)';
		colorScheme.background = 'rgb(0, 0, 0)';
		colorScheme.grid = 'rgb(120, 120, 120)';
	}
	return colorScheme;
}

/**
 * Custom plugin to add spacing to the legend
 *
 * @see https://github.com/chartjs/Chart.js/issues/10388
 *
 * @type {{beforeInit(*): void}}
 */
const legendSpacing = {
	beforeInit(chart) {
		// Get a reference to the original fit function
		const originalFit = chart.legend.fit;

		// Override the fit function
		chart.legend.fit = function fit() {
			// Call the original function and bind scope in order to use `this` correctly inside it
			originalFit.bind(chart.legend)();
			this.height += 15;
		}

		chart.options.plugins.title.padding = {
			top: 10,
			bottom: 10
		};
	}
}

export {responsiveTickLabelSize, responsiveDataLabelSize, colorScheme, legendColors, legendSpacing, chartColors};
